'use client';

import { useBuyContext } from '../../state/BuyContext';
import { useBuySelection } from '../../state/useBuySelection';
import { resolve, type PillGroupCardConfig } from '../../state/cardSchema';
import { Section } from '../Section';
import styles from './PillCard.module.css';

export type PillCardProps = {
  card: PillGroupCardConfig;
};

export const PillCard = ({ card }: PillCardProps) => {
  const { resolveCtx } = useBuyContext();
  const { selected, select, isSelected, toggle } = useBuySelection(card.id);
  const isMulti = card.selection === 'multi';

  const handleClick = (optionId: string) => {
    if (isMulti) {
      toggle(optionId);
    } else {
      // Toggle off if already selected (single-select).
      select(selected === optionId ? null : optionId);
    }
  };

  return (
    <Section id={card.id} title={card.title} subtitle={card.subtitle} info={card.info}>
      <div className={styles.row} role={isMulti ? 'group' : 'radiogroup'} aria-label={typeof card.title === 'string' ? card.title : card.id}>
        {card.options.map((option) => {
          const active = isSelected(option.id);
          const disabled = !!resolve(option.disabled, resolveCtx);
          return (
            <button
              key={option.id}
              type="button"
              className={styles.pill}
              data-active={active ? 'true' : 'false'}
              onClick={() => handleClick(option.id)}
              disabled={disabled}
              role={isMulti ? 'checkbox' : 'radio'}
              aria-checked={active}
            >
              {option.label}
              {option.badge ? <span className={styles.badge}>{option.badge}</span> : null}
            </button>
          );
        })}
      </div>
    </Section>
  );
};
